import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext.jsx';

/** Ruta protegida por sesión. `permiso` opcional: además exige ese permiso puntual. */
const PrivateRoute = ({ children, permiso }) => {
  const { isAuth, hasPermiso } = useContext(AuthContext);
  if (!isAuth) return <Navigate to="/login" replace />;
  if (permiso && !hasPermiso(permiso)) return <Navigate to="/" replace />;
  return children;
};

export default PrivateRoute;
